/* eslint-disable import/prefer-default-export */
import { styled } from 'styletron-react'

export const BBCodeContainer = styled('div', () => ({
  whiteSpace: 'pre-wrap',
}))
